import { render, staticRenderFns } from "./modifyOTAForm.vue?vue&type=template&id=58cec4c9&scoped=true"
import script from "./modifyOTAForm.vue?vue&type=script&lang=js"
export * from "./modifyOTAForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58cec4c9",
  null
  
)

export default component.exports